const pallete = [
  '#9F9F9F',
  '#F8981D',
  '#0FAB76',
  '#0597E0',
  '#F11357',
  '#0A3A9B',
  '#6884BF',
  '#787B83',
  '#1F2532',
];

const palleteLength = pallete.length;

const randomizeColors = () => {
  const index = Math.floor(Math.random() * palleteLength);
  return pallete[index];
};

const allRandomizeColors = function randomizeColors() {
  const color = Math.floor(Math.random()*16777215).toString(16)
  return `#${color}`;
};

export default {randomizeColors, allRandomizeColors};
